const isBlackouted = (blackoutDates, { departureDate, returnDate }) =>
  blackoutDates.departure[departureDate] || blackoutDates.return[returnDate];

export default isBlackouted;
